import React, { useState } from 'react'
import { useOwnerPage } from './hook'
import { MainTemplate } from '../../templates/MainTemplate'
import { TableTemplate } from '../../templates/TableTemplate'
import { CreateOwnerModal } from '../../organisms/modal/CreateOwnerModal'
import { EditOwnerModal } from '../../organisms/modal/EditOwnerModal';
import { DetailOwnerModal } from '../../organisms/modal/DetailOwnerModal';
import { Owner } from '../../../ducks/owner/types'
import { SearchForm } from '../../organisms/form/SearchForm'
import { Resource, Permission } from '../../../constants/permissions'
import { useOwnerToast } from './hook';

export const OwnerPage = () => {
  const { showToast } = useOwnerToast();
  const {
    tableHeaders,
    owners,
    fetchDataFunction,
    isCreateModalOpen,
    isEditModalOpen,
    isDetailModalOpen,
    selectedOwner,
    handleOpenCreateModal,
    handleCloseCreateModal,
    handleCloseEditModal,
    handleOpenEditModal,
    handleCloseDetailModal,
    handleOpenDetailModal,
    handleRowDelete,
    page,
    pageSize,
    totalItems,
    hasPagination,
    searchTerm,
    handleSearchChange,
    handlePageChange,
    refetchOwners
  } = useOwnerPage()

  // Search state (for now, just UI)
  const [search, setSearch] = useState("");

  return (
    <>
      <MainTemplate
        title='Owners'
        useFitHeight
      >
        <SearchForm
          searchValue={searchTerm}
          onSearchChange={handleSearchChange}
          onCreateClick={handleOpenCreateModal}
          createButtonText="Create"
          searchPlaceholder="Search by name..."
          isCreateButtonDisabled={isCreateModalOpen}
        />
        <TableTemplate<Owner & { no: number }>
          headers={tableHeaders}
          data={owners}
          fetchDataFunction={fetchDataFunction}
          columnWidths={["6%", "30%", "30%", "30%"]} // No: 10%, ...
          hasPagination={hasPagination}
          perPage={pageSize}
          total={totalItems}
          currentPage={page}
          defaultSort={{ field: 'name', order: 'asc' }}
          editable
          deletable
          showHeaderDeleteIcon={false}
          resource={Resource.OWNERS}
          onPermissionError={showToast}
          // enableHoverPopup
          onDelete={handleRowDelete}
          onEdit={(owner) => {
            handleOpenEditModal(owner);
          }}
          stickyHeader
          onSetPage={handlePageChange}
        />
      </MainTemplate>

      <CreateOwnerModal
        isOpen={isCreateModalOpen}
        onClose={handleCloseCreateModal}
        refetchOwners={refetchOwners}
      />

      {selectedOwner && (
        <EditOwnerModal
          isOpen={isEditModalOpen}
          onClose={handleCloseEditModal}
          defaultValues={{
            name: selectedOwner.name,
            phoneNumber: selectedOwner.phone_number,
            email: selectedOwner.email,
            otherPhoneNumber: selectedOwner.other_phone_number,
          }}
          ownerId={selectedOwner.id}
          refetchOwners={refetchOwners}
        />
      )}

      {selectedOwner && (
        <DetailOwnerModal
          isOpen={isDetailModalOpen}
          onClose={handleCloseDetailModal}
          owner={selectedOwner}
        />
      )}
    </>
  )
}
